
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  display:block;
}

.fsBody {
  font-family:var(--bh-ff-body) !important;
}

input:focus, select:focus, textarea:focus {
  border-width:2px !important;
  border-color:var(--bh-brand-primary-default) !important;
}

input[type='radio']:focus:before,
input[type='checkbox']:focus:before,
input[type='button']:focus,
button[type='button']:focus,
input[type='submit']:focus{
  outline-style:solid !important;
  outline-width:2px !important;
  outline-color:var(--bh-brand-primary-default) !important;
}

input[type='radio'],
input[type='checkbox']{
  overflow:visible !important;
}

input[type='checkbox']:checked:before {
  border-color:var(--bh-brand-primary-default) !important;
  background-color:var(--bh-brand-primary-default) !important;
}

input[type='radio']:checked:before {
  border-color:var(--bh-brand-primary-default) !important;
}

@media (max-width: 768px){
    .fsform-container .fsBody {
    width:100% !important;
  }

    .fsform-container form {
    margin:0px !important;
  }

    .fsform-container form {
    width:100% !important;
  }
      .fsform-container form .fsSection{
        grid-template-columns:100%;
      }

    .fsform-container [class^='EventProductField__StyledEventContainer'] {
    display:grid;
  }

    .fsform-container [class^='EventProductField__StyledEventContainer'] {
    gap:1.25rem;
  }

      .fsform-container [class^='EventProductField__StyledEventContainer'] * {
    width:100%;
  }
}

:host([site='BH']) .fsform-container a{
      color:#007cc2;
      text-decoration:underline;
    }

:host([site='BH']) .fsform-container input[type='checkbox']:checked:before{
      background-color:#007cc2;
      border-color:#007cc2;
      position:absolute;
    }

:host([site='BH']) .fsform-container input[type='radio']:checked:before{
      border-color:#007cc2;
    }

:host([site='BH']) .fsform-container ol,
    :host([site='BH']) .fsform-container ul{
      list-style:inherit;
      font-size:0.75rem;
    }

:host([site='BH']) .fsform-container p{
      font-size:0.75rem;
    }

:host([site='BH']) .fsform-container .fsBody .fsSectionHeader{
      padding:0;
    }

:host([site='BH']) .fsform-container form p > img{
      margin:auto;
    }

:host([site='BH']) .fsform-container ul,
    :host([site='BH']) .fsform-container li,
    :host([site='BH']) .fsform-container a,
    :host([site='BH']) .fsform-container label{
      all:revert;
    }

:host([site='BH']) .fsform-container [class^='StyledSupportingText-']{
      font-size:0.8rem;
    }

:host([site='BH']) .fsform-container [class^='StyledReferralBadge-']{
      display:none;
    }
`;